// Cart drawer upsell "Dodaj" handler (polskasypialnia, 2026-10-19).
// Adds the variant via /cart/add.js, requesting the HTML of every
// cart-items-component section, then dispatches Horizon's own CartAddEvent so
// the drawer contents, cart bubble and totals are morphed in place (same path
// the product form uses). The upsell block itself is server-rendered inside the
// drawer section, so the added product disappears after the morph.
import { CartAddEvent } from '@theme/events';

if (!window.__psCartUpsellBound) {
  window.__psCartUpsellBound = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-cart-upsell-add]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    event.preventDefault();

    const container = button.closest('[data-cart-upsell]');
    const errorEl = container?.querySelector('[data-cart-upsell-error]');
    const variantId = Number(button.dataset.variantId);
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = '…';
    if (errorEl) errorEl.hidden = true;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : ''))
      .filter(Boolean);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: [...new Set(sectionIds)].join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Nie udało się dodać produktu.');
      }

      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

      button.dispatchEvent(
        new CartAddEvent(cart, String(variantId), {
          source: 'cart-drawer-upsell',
          itemCount: cart.item_count,
          variantId: String(variantId),
          sections: data.sections,
        })
      );
    } catch (error) {
      console.warn('[cart-upsell]', error);
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = originalText;
      }
      if (errorEl && errorEl.isConnected) {
        errorEl.textContent = error instanceof Error ? error.message : 'Nie udało się dodać produktu.';
        errorEl.hidden = false;
      }
    }
  });
}
